<div>
  <!-- Boton de idioma -->
  <div class="position-absolute mt-2 mr-2 buttonClose animate__animated animate__delay-2s bounceIn">
    <button class="btn btn-icon p-2" [ngStyle]="{'background': menu.color,'color': menu.colorText,'border-color': menu.color}" type="button" (click)="selectLanguage()"
      *ngIf="language? 'ES':'EN'">
      <i class="fas fa-globe-americas m--1" [ngClass]="{'fa-flag': language == 'ES', 'fa-flag-usa' : language == 'EN' }"></i>
      <span class="btn-inner--text">{{ language }}</span>
    </button>
  </div>
  <!-- Cabezote del menu -->
  <img [src]="menu?.photo" alt="" class="coverPage">
</div>
<div class="row p-4" [ngStyle]="{'background': menu.color}" id="indexsection">
  <div class="col-12 p-4 menu-index rounded" [ngStyle]="{'border-color': setBackground()}">
    <div class="row" *ngFor="let section of menu.sections; let index = index" [hidden]="section.type === TYPE_SECTIONS.additions">
      <div class="col menu-index-section {{menu.fontSections? menu.fontSections: menu.fontHeader}}">
        <strong [ngStyle]="{'color': menu.colorText}" (click)="selectSection(section)">
          <ng-container *ngIf="language === 'ES'">
            {{ section.name | uppercase }}
          </ng-container>
          <ng-container *ngIf="language === 'EN'">
            {{ section.nameEn | uppercase }}
          </ng-container>
        </strong>
      </div>
    </div>
  </div>
</div>
<div class="row p-4 menu-container" *ngIf="menu.color" [ngStyle]="{'background': menu.color}">
  <div class="col-12 mb-2 rounded" *ngFor="let section of menu.sections; let index = index" [id]="section.name + 'section'" [ngStyle]="{'border-color': setBackground()}"
    [hidden]="section.type === TYPE_SECTIONS.additions" [ngClass]="{'menu-section-container': (section.type !== TYPE_SECTIONS.gallery && section.type !== TYPE_SECTIONS.videos)}">
    <!-- Nombre de la seccion -->
    <div class="row">
      <div class="col-12" *ngIf="!section.photo && section.type !== TYPE_SECTIONS.gallery && section.type !== TYPE_SECTIONS.videos" [ngStyle]="{'background': setBackground()}">
        <h1 class="meal-title font-weight-bold {{menu.fontSections? menu.fontSections: menu.fontHeader}} p-4 justify-content-center" [ngStyle]="{'color': setColorText()}"
          translate="no">
          <ng-container *ngIf="language === 'ES'">
            {{ section.name | uppercase }}
          </ng-container>
          <ng-container *ngIf="language === 'EN'">
            {{ section.nameEn | uppercase }}
          </ng-container>
        </h1>
      </div>
      <!-- Foto de la seccion  con texto puesto por eazzy-->
      <div class="col-12 align-items-center justify-content-center d-flex" *ngIf="section.photo && section.text">
        <h1 class="{{menu.fontSections? menu.fontSections: menu.fontHeader}} font-weight-bold position-absolute section-name animate__animated animate__delay-2s fadeIn"
          style="color: white; z-index:1">
          {{ language === 'ES'? section.name: section.nameEn}}</h1>
        <img [src]="bannerImage" [alt]="isInViewport(section, section.photo)" [id]="section.photo" class="img-fluid animate__animated" style="width: 100%;">
      </div>
      <!-- Foto de la seccion sin texto-->
      <div class="col-12" *ngIf="section.photo && !section.text">
        <img [src]="noImage" [alt]="isInViewport(section, section.photo)" [id]="section.photo" class="img-fluid animate__animated" style="width: 100%;">
      </div>
    </div>
    <!-- Secciones -->
    <div class="row body justify-content-center" [ngStyle]="{'background': 'transparent'}">
      <!-- Items de secciones con foto -->
      <app-item-image [section]="section" [menu]="menu" class="w-100" *ngIf="section.type === TYPE_SECTIONS.productsMenu|| section.type === TYPE_SECTIONS.productsOnlyPhoto">
      </app-item-image>
      <!-- Items de secciones con o sin logo en modo listado -->
      <app-item-list *ngIf="section.type === TYPE_SECTIONS.productList" [section]="section" [menu]="menu" class="w-100">
      </app-item-list>
      <!-- Items de secciones en modo listado simple -->
      <app-item-simple-list *ngIf="section.type === TYPE_SECTIONS.productSimpleList" [section]="section" [menu]="menu" class="w-100">
      </app-item-simple-list>
      <!-- Items de secciones de listado solo con descripciones -->
      <app-item-only-description [section]="section" [menu]="menu" *ngIf="section.type === TYPE_SECTIONS.onlyDescription" class="w-100"></app-item-only-description>
      <!-- Items de secciones de bebidas alcoholicas -->
      <app-item-drinks *ngIf="section.type === TYPE_SECTIONS.drinks || section.type === TYPE_SECTIONS.wines" [section]="section" [menu]="menu" class="w-100">
      </app-item-drinks>
      <!-- Items de secciones de bebidas alcoholicas -->
      <app-item-drink-midle *ngIf="section.type === TYPE_SECTIONS.drinks_midle" [section]="section" [menu]="menu" class="w-100">
      </app-item-drink-midle>
      <!-- Items de secciones de galeria de imagenes -->
      <app-item-gallery [section]="section" *ngIf="section.type === TYPE_SECTIONS.gallery"></app-item-gallery>
      <!-- Items de secciones de galeria de videos -->
      <app-item-video [section]="section" *ngIf="section.type === TYPE_SECTIONS.videos"></app-item-video>
      <!-- Items de secciones de adiciones -->
      <app-item-list-additions *ngIf="menu.sections[index + 1]?.type === TYPE_SECTIONS.additions" [section]="menu.sections[index + 1]" [menu]="menu" class="w-100">
      </app-item-list-additions>
      <!-- Descripcion de la seccion -->
      <div class="justify-content-center text-center d-flex text-center p-2 mb-5" *ngIf="section.description">
        <p [ngStyle]="{'color': menu.colorText}" class="mb-4 {{menu.fontText}} font-weight-bold">
          {{ language === 'ES'? section.description: section.descriptionEn }}
        </p>
      </div>
      <div class="row menu-buttonBack-container" [ngStyle]="{'background': menu.colorText}" (click)="filterSection('index')"
        *ngIf="section.type !== TYPE_SECTIONS.gallery && section.type !== TYPE_SECTIONS.videos">
        <div class="col">
          <h5 [ngStyle]="{'color': menu.color}" (click)="filterSection('index')" class="{{menu.fontSections? menu.fontSections: menu.fontHeader}}">
            <a (click)="filterSection('index')">{{ language === 'ES'? 'VOLVER AL MENÚ PRINCIPAL' : 'BACK TO MAIN MENU' }}</a>
          </h5>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row mb-7">
  <div class="col-12">
    <app-menu-selectors [menu]="menu"></app-menu-selectors>
  </div>
</div>

<!-- <div class="menu-toTop mt-2 mr-2 buttonClose" id="scrollButton">
  <button class="btn btn-icon p-2" [ngStyle]="{'color': menu.color,'background': menu.colorText,'border-color': menu.colorText}" type="button" (click)="filterSection('index')">
    <i class="fas fa-arrow-up"></i>
  </button>
</div> -->